window.$ = window.jQuery;


jQuery(document).ready(function () {
    if (jQuery('.js-sidebar-latest').length > 0) {
        jQuery.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: 'render-last-deals',
                mode: 'wide'
            },
            success: function (response) {
                jQuery('.loading-last-deals').hide();
                jQuery('.last-deals-data').html(response);
            }
        });
    }
});